import { Components } from "appworks/components/components";
import { PromptComponent } from "appworks/components/prompt/prompt-component";
import { PromptContentSubcomponent } from "appworks/components/prompt/prompt-content-subcomponent";
import { Layers } from "appworks/graphics/layers/layers";
import { gameState } from "appworks/model/game-state";
import { Services } from "appworks/services/services";
import { TranslationsService } from "appworks/services/translations/translations-service";
import { State } from "appworks/state-machine/states/state";
import { UIFlag, uiFlags } from "appworks/ui/flags/ui-flags";

export class RetriggerFreespinsState extends State {

    public onEnter() {
        uiFlags.set(UIFlag.PROMPT, true);

        this.showPrompt();
    }

    public complete() {
        uiFlags.set(UIFlag.PROMPT, false);
        uiFlags.set(UIFlag.FREE_SPINS, true);

        super.complete();
    }

    protected showPrompt(prompt?: PromptContentSubcomponent) {
        if (!prompt && Layers.get("Prompts").hasAnyScene(["freespinsretrigger", "freespinswin", "freespins"])) {
            prompt = new PromptContentSubcomponent(["freespinsretrigger", "freespinswin", "freespins"], 2000);
        }

        if (prompt) {
            const record = gameState.getCurrentGame().getCurrentRecord();

            prompt.setText("winMessage", Services.get(TranslationsService).getFirstValid(["extra_free_spins_awarded"], { VALUE: record.getFreespinsWon() }));
            prompt.addContinueButton("continue");

            Components.get(PromptComponent).showPrompt(prompt).then(() => this.complete());

        } else {
            this.complete();
        }
    }
}
